import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { Signin } from "./pages/authentication/signin";
import { PasswordRecovery } from "./pages/authentication/passwordrecovery";
import { Dashboard } from "./pages/app/dashboard";
import { CreateInstitution } from "./pages/app/institutions/createinstitution";
import { ListOfInstitutions } from "./pages/app/institutions/listofinstitutions";
import { EditInstitution } from "./pages/app/institutions/editinstitution";
import { Profile } from "./pages/app/profile";
import { AccessControl } from "./pages/app/usermanagement/accesscontrol";
import { UserRole } from "./pages/app/usermanagement/userrole";
import { SystemUsers } from "./pages/app/usermanagement/systemusers";
import { SMSAlert } from "./pages/app/configuration/smsalert";
import { Currency } from "./pages/app/configuration/currency";
import { SMSBalance } from "./pages/app/accounting/smsbalance";
import { AddSystemUser } from "./pages/app/usermanagement/systemusers/addsystemuser";
import { EditSystemUser } from "./pages/app/usermanagement/systemusers/editsystemuser";
import { AddSMSAlert } from "./pages/app/configuration/smsalert/addsmsalert";
import { EditSMSAlert } from "./pages/app/configuration/smsalert/editsmsalert";
import { AddCurrency } from "./pages/app/configuration/currency/addcurrency";
import { EditCurrency } from "./pages/app/configuration/currency/editcurrency";
import { TopUp } from "./pages/app/accounting/topup";
import { RouteProtector } from "./config/routeProtector";
import { ListOfMigrations } from "./pages/app/migration/listofmigrations";
import { AddMigration } from "./pages/app/migration/addmigration";

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Signin />} />
				<Route
					path="/passwordrecovery/:action"
					element={<PasswordRecovery />}
				/>
				<Route element={<RouteProtector />}>
					<Route path="/profile" element={<Profile />} />
					<Route path="/dashboard" element={<Dashboard />} />
					<Route
						path="/institution/createinstitution"
						element={<CreateInstitution />}
					/>
					<Route
						path="/institution/listofinstitutions"
						element={<ListOfInstitutions />}
					/>
					<Route path="/institution/edit/:id" element={<EditInstitution />} />
					<Route
						path="/usermanagement/accesscontrol"
						element={<AccessControl />}
					/>
					<Route path="/usermanagement/userrole" element={<UserRole />} />
					<Route path="/usermanagement/systemusers" element={<SystemUsers />} />
					<Route
						path="/usermanagement/systemusers/addsystemuser"
						element={<AddSystemUser />}
					/>
					<Route
						path="/usermanagement/systemusers/editsystemuser/:id"
						element={<EditSystemUser />}
					/>
					<Route
						path="/usermanagement/accesscontrol/:id?"
						element={<AccessControl />}
					/>
					<Route path="/configuration/smsalert" element={<SMSAlert />} />
					<Route
						path="/configuration/smsalert/addsmsalert"
						element={<AddSMSAlert />}
					/>
					<Route
						path="/configuration/smsalert/editsmsalert/:id"
						element={<EditSMSAlert />}
					/>
					<Route path="/configuration/currency" element={<Currency />} />
					<Route
						path="/configuration/currency/addcurrency"
						element={<AddCurrency />}
					/>
					<Route
						path="/configuration/currency/editcurrency/:id"
						element={<EditCurrency />}
					/>
					<Route path="/accounting/checksmsbalance" element={<SMSBalance />} />
					<Route path="/accounting/smstopup" element={<TopUp />} />
					<Route path="/migration" element={<ListOfMigrations />} />
					<Route path="/migration/migratedata" element={<AddMigration />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
